<script>
    export default {
        name: 'InspectionAction',
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        methods: {
            detailsButtonClicked() {
                this.$store.dispatch('conduct/issueItemModalOpened', this.item);
            },
        },
    };
</script>

<template>
    <div class="mb-6" v-if="item.visible_for_conductor">
        <h2 v-if="item.executed_at">
            {{ $t('The issue was raised at "{date}".', { date: $du(item.executed_at, 'shortDateTime') }) }}
        </h2>
        <h2 v-else>
            {{ $t('Hint: When you submit your check results, issue "{issue}" is raised automatically.', { issue:
            item.params.title }) }}
        </h2>

        <button class="btn btn-default btn-primary main-button relative"
                @click="detailsButtonClicked"
        >
            {{ $t('See details') }}
        </button>
    </div>
</template>
